import styled from 'styled-components';

export const HeaderText = styled.span`
  font-weight: bold;
  font-size: 13px;
  color: rgba(0, 0, 0, 0.54);
  font-size: 0.75rem;
`;
